<template>
	<div class='' style="height:100%;width:100%;margin: 0; padding: 0;">
		<div id="cesiumContainer" class="ab"></div>
		<div>{{pmsg_div}}</div>
	</div>
</template>

<script>
import * as  Cesium from  'cesium/Cesium';
import widgets from 'cesium/Widgets/widgets.css';
import wifiImg from "@/assets/3d/wifi.png";
import dev48 from '@/assets/3d/dev-48.png';
import dev49 from '@/assets/3d/dev-49.png';
import dev59 from '@/assets/3d/dev-59.png';
import dev128 from '@/assets/3d/dev-128.png';
import dev129 from '@/assets/3d/dev-129.png';
import dev131 from '@/assets/3d/dev-131.png';
import dev167 from '@/assets/3d/dev-167.png';
import dev168 from '@/assets/3d/dev-168.png';
import dev169 from '@/assets/3d/dev-169.png';
import $ from 'jquery';
import {selectRealSceneData, selectDevRealData} from "@/api/3d/iotReq";
export default {
	name: 'cesiumViewer',
	data(){
		return {
			loading: true,
			dataRequest : {
				dm: '421024106203001', 
				mc: '颜闸村丰泽园', 
				ssxqmc: '荆州市江陵县郝穴镇颜闸村', 
				tileUrl: 'http://www.is51.cn:9001/data_cesium/颜闸村/倾斜/tileset.json', 
				viewx: -2109972.236535511, 
				viewy: 5109465.627192092, 
				viewz: 3171161.404941637, 
				heading: 3.7894661189281797, 
				pitch: -0.6252599765489384, 
				roll :0.0,
				iots: [
					{devid: '1020FF01D3A100A0', devmc: '大棚采集站', x: 112.4373, y: 30.0058},  
				    {devid: '0007C802D4A100F2', devmc: '气象采集站\n30℃', x: 112.43775, y: 30.00660}
				]
			},
			devData: {
				devid: '1020FF01D3A100A0',
				update: '2020-09-16 15:30:20', 
				sblb: [
					{code: '48', name: 'CO2浓度', value: '462ppm', state: '紧急'}, 
					{code: '49', name: '光照度', value: '29997lux', state: '异常'},
					{code: '59', name: 'PH', value: '7.6', state: '正常'},
					{code: '167', name: '光合有效辐射', value: '98W/S2', state: '离线'},
					{code: '168', name: '空气温度', value: '32.6℃', state: '正常'},
					{code: '169', name: '空气湿度', value: '66.7%', state: '异常'}
				]
			},
			viewer: null,
			pmsg_div: '',
			g_iot_list: [],
			intervalIOT: null
		}
	},
	components: {

	},
	created(){
		
	},
	mounted(){
		this.init();
	},
	methods: {
		init(){
			//Cesium.Ion.defaultAccessToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMjJjMzI5YS1jZWRkLTQ1YTEtOTIzMy1lNDlmNmQyM2M0YmYiLCJpZCI6MzM2NjksImlhdCI6MTU5OTA1MDM1MH0.Aofdn9ZlfkxQl7W7F-O2XKrz5Ga8hWooRj-CkHuXeEs';
			var Cesium = this.Cesium;
			this.viewer = new Cesium.Viewer('cesiumContainer',{
				baseLayerPicker:false,
				timeline:false,
				homeButton:false,
				fullscreenButton:false,
				infoBox:false,
				sceneModePicker:false,
				navigationInstructionsInitiallyVisible:false,
				navigationHelpButton:false,
				geocoder:false,
				animation:false,
				selectionIndicator:false,
				creditsDisplay: false
			});
			this.viewer.cesiumWidget.creditContainer.style.display = 'none';
			this.viewer.scene.postProcessStages.fxaa.enabled = false;
			this.viewer.scene.globe.enableLighting = true;
	        console.log('----初始化地球----');

            // this.$api.post('/iot/analysis/time/selectRealSceneData', {
          	// 	siteId: 114}).then(res => {
			// 		  console.log("response");
			// 		  if (res.code === 200) {
			// 			if (res.data) {
			// 				this.dataRequest = res.data;
			// 				this.showTile(this.dataRequest);
			// 			}
			// 		  }
			// 	  });
			selectRealSceneData({siteId: 114}).then(res => {
				console.log("response scene");
				if (res.code === 200) {
				if (res.data) {
					this.dataRequest = res.data;
					this.showTile(this.dataRequest);
				}
				}
			});
		},
		
		showTile(data){
			//document.getElementById('id_div_name').innerHTML = data.mc;
			//document.title = data.mc;
			this.g_iot_list = [];
			var tileset = new Cesium.Cesium3DTileset({
				url: data.tileUrl,
				visibleRange : { max: 22000 },
				dynamicScreenSpaceError : true,
				dynamicScreenSpaceErrorDensity : 0.00278,
				dynamicScreenSpaceErrorFactor : 4.0,
				dynamicScreenSpaceErrorHeightFalloff : 0.25,
				maximumScreenSpaceError : 50,
				maximumNumberOfLoadedTiles : 50000
			});
			this.viewer.scene.primitives.add(tileset);
			//viewer.zoomTo(tileset);
            console.log('----加载村场景----');
			var viewPoint = {x: data.viewX, y: data.viewY, z: data.viewZ};
			//Cesium.Cartesian3.fromDegrees(112.43750875265964,30.005589995975487, 100);
			var hcv = {
				destination: viewPoint,
				orientation: {
					heading : data.heading, //Cesium.Math.toRadians(0.0),
					pitch : data.pitch, //Cesium.Math.toRadians(-35.0),
					roll : data.roll
				}
			}
			//viewer.camera.setView(hcv);
			this.viewer.camera.flyTo(hcv);
			this.showIOT(data.devList);// data.iots
		},

		showIOT(data){	
			for( var i in data){
				var entity = this.initPoint(data[i]);	
				
				var geometry = Cesium.Cartesian3.fromDegrees(data[i].x, data[i].y,50);
				var position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, geometry);
				var _html = '<div id="div_'+data[i].devId+'" class="cls-div-tip" style="top:'+position.y+'px;left:'+position.x+'px;">';
				_html += '</div>';
				//this.pmsg_div = _html;
				$('#cesiumContainer').append(_html);
			}
			//请求物联网详细信息
			this.requestAllIOT();
			this.intervalIOT = setInterval(this.requestAllIOT,60000);

			var me = this;
			this.viewer.clock.onTick.addEventListener(function(clock) {
				me.render(data);
			})

			//单击事件
			//var me = this;
			var handler = new Cesium.ScreenSpaceEventHandler(me.viewer.scene.canvas);
			//调用setInputAction方法
			handler.setInputAction(function(movement){
				
				var cartesian = me.viewer.camera.pickEllipsoid(movement.position, me.viewer.scene.globe.ellipsoid);
				if(cartesian){
					//将笛卡尔三维坐标转为地图坐标（弧度）
					var cartographic = me.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
					//将地图坐标（弧度）转为十进制的度数
					var lat=Cesium.Math.toDegrees(cartographic.latitude);
					var lon=Cesium.Math.toDegrees(cartographic.longitude);
					console.log(lon, lat);
				}

				//获取pick的object，如果使用click类型的鼠标操作，则相应的选择pick和pick.position
				var pickOdv = me.viewer.scene.pick(movement.position);
				var pick_entity = (Cesium.defined(pickOdv)) ? pickOdv.id :undefined;
				if(pickOdv && pickOdv.id){
					console.log(pick_entity.id);
					$('#div_'+pick_entity.id).toggle();
				}

			},Cesium.ScreenSpaceEventType.LEFT_CLICK);
		},

		initPoint(item){
			var point = this.viewer.entities.add({
				id:item.devId,
				name : item.devName,
				position:Cesium.Cartesian3.fromDegrees(item.x,item.y,50),
				
				billboard:{
					image: wifiImg,
					width: 38,
					height: 50,
					scaleByDistance: new Cesium.NearFarScalar(100, 1.0, 1e4, 0.5)//,
					//scale: 1//,//0.6,
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND
				},
				label:{
					text:item.devName,
					font:'14px sans-serif',
					style: Cesium.LabelStyle.FILL_AND_OUTLINE,
					fillColor: Cesium.Color.AQUAMARINE,
					backgroundColor: new Cesium.Color(0, 0, 0, .9),
				//    clampToGround:false,
					//scale: 0.8,
					horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
					verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
					disableDepthTestDistance: 100.0,
					pixelOffset:new Cesium.Cartesian2(0, -30),
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND,
					showBackground:true
				}
			});
			this.g_iot_list.push(point);
			//line
			var position1 = Cesium.Cartesian3.fromDegrees(item.x,item.y,48);
			var position2 = Cesium.Cartesian3.fromDegrees(item.x,item.y,0);
			this.viewer.entities.add({
					polyline: {
						positions: [position1, position2],
						clampToGround: false,
						//material: Cesium.Color.RED,
						width: 1
					}
				});
			
			//tempEntity.push(point);
			return point;
		},

		requestAllIOT(){
			for(var i in this.dataRequest.devList){
				this.requestIOTDetailById(this.dataRequest.devList[i].devId);
			}
		},

		requestIOTDetailById(devId){
			console.log(devId, '---请求物联网信息--')
			selectDevRealData({devId: devId}).then(res => {
				if (res.code === 200) {
					if (res.data) {
						this.updateIOTDetail(res.data);
					}
				}
			}).catch(err =>{
				console.log(err);
				$('#div_' + devId).hide();
			});
		},

		updateIOTDetail(data){
			//
			var _html = '';
			_html += '<h4 class="cls-tip-name" title="物联网设备信息更新的时间">'+data.updateTime+'</h4>'; //data[i].devmc
				_html += '<ul class="cls-ul-sblb">';
				for(var j in data.realDevList){
					_html += '<li>';
						var _imgsrc = dev48;
						switch(data.realDevList[j].code){
							case 48:_imgsrc = dev48;break;
							case 49:_imgsrc = dev49;break;
							case 59:_imgsrc = dev59;break;
							case 128:_imgsrc = dev128;break;
							case 129:_imgsrc = dev129;break;
							case 131:_imgsrc = dev131;break;
							case 167:_imgsrc = dev167;break;
							case 168:_imgsrc = dev168;break;
							case 169:_imgsrc = dev169;break;
							case 170:_imgsrc = dev168;break;
							case 171:_imgsrc = dev169;break;
						}
						_html += '<img src="'+_imgsrc+'">';
						_html += '<div class="cls-div-msg-key">';
							_html += '<div class="cls-div-msg-name">' +data.realDevList[j].name+'</div>';
							_html += '<div class="cls-div-msg-value">'+data.realDevList[j].value+'</div>' 
						_html += '</div>';
						var _state = data.realDevList[j].state;
						var _state_color = 'cls-state-1';
						var _str_state = '';
						switch(_state){
							case 0: _state_color = 'cls-state-0'; _str_state = '离线'; break;
							case 1: _state_color = 'cls-state-1'; _str_state = '正常'; break;
							case 2: _state_color = 'cls-state-2'; _str_state = '异常'; break;
							case 3: _state_color = 'cls-state-3'; _str_state = '紧急'; break;
						}
						_html += '<div class="cls-div-msg-state '+_state_color+'">' + _str_state + '</div>';
					_html += '</li>';
				}
				_html += '</ul>';
				$('#div_' + data.devId).html(_html);
		},

		render(data){
			for( var i in data){
				var _dom = document.getElementById('div_'+data[i].devId);
				var geometry = Cesium.Cartesian3.fromDegrees(data[i].x, data[i].y, 50);
				var position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, geometry);
				if(position){
					_dom.style.left = (position.x+20) + 'px';//+19
					_dom.style.top = (position.y+50) + 'px';//-25
				}
			// _this.ctn.css("left",position.x- _this.ctn.get(0).offsetWidth/2);
			// _this.ctn.css("top",position.y- _this.ctn.get(0).offsetHeight - 10);
			}
		},
		clear() {
			clearInterval(this.intervalIOT);
			console.log("--3d结束了");
		}
		
	},
	beforeDestroy() {
		//离开当前页面后执行
		this.clear();
	}
}
</script>
<style lang='scss' scoped>
</style>
<style>
#cesiumContainer{height:100%; width:100%}
#id_div_title{position:absolute;top:0;left:0;width:100%;height:50px;background-color:black;color:white;opacity:0.5;}
#id_div_name{font-size:18px;line-height:46px;padding-left:10px;}
.cls-div-tip{position:absolute;z-index:100;border:1px solid #edffff;opacity:0.8;display:block;
	background-color:black;color:yellow;padding:5px 20px;border-radius:5px}
.cls-tip-name{color: AQUAMARINE; margin-bottom: 2px;}
.cls-div-msg-name, .cls-div-msg-value{color: white;width:100px;text-align: left;font-size:10px;}
.cls-div-msg-state{float: left;height: 32px; line-height: 32px;font-size:12px;}
.cls-div-msg-key{float: left;}
.cls-ul-sblb li{margin:1px 1px 1px 5px;height: 35px;color: #57ea3c;list-style: disc;}
.cls-ul-sblb img{float: left;width: 20px;height: 20px; margin: 5px 8px 0 0;}
.cls-state-0{color: gray;}
.cls-state-1{color: green;}
.cls-state-2{color: orange;}
.cls-state-3{color: red;}
</style>
